import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetokolhpaurcab() {



  const cardData =
  {
    keyword: 'Pune to Kolhapur Cab',
    heading: 'Sai Trupti Cabs: Pune to Kolhapur Cab',
    headingDescription: 'Sai Trupti Cabs offers reliable and comfortable Pune to Kolhapur cab hire services, designed to make your inter-city journey smooth and stress-free. Our fleet includes well-maintained, air-conditioned Sedans, SUVs, and Premium vehicles — all equipped with clean interiors and ample luggage space. Every journey is driven by a professional, background-verified chauffeur who ensures punctual pickup in Pune, courteous service, and safe, smooth driving all the way to Kolhapur. With transparent one-way fares, flexible booking options (one-way or round-trip), and 24 × 7 customer support, Sai Trupti Cabs makes your travel from Pune to Kolhapur convenient, affordable and worry-free.',

    top: 'Top Places to Visit in Kolhapur with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Mahalaxmi Temple",
    "description": "The Mahalaxmi Temple of Kolhapur, dedicated to Goddess Ambabai, is one of the most sacred Shakti Peethas in India. Built in the 7th century, the temple’s black stone architecture, intricate carvings, and spiritual aura draw devotees from across the country. The daily rituals, ringing bells, and divine chants create an atmosphere of devotion and calm. During Navratri and Kirnotsav, sunlight directly illuminates the idol — a rare celestial spectacle. The temple stands as the spiritual and cultural heart of Kolhapur, radiating peace, prosperity, and faith through centuries of worship."
  },
  {
    "title": "Rankala Lake",
    "description": "Rankala Lake is Kolhapur’s most scenic waterfront, known for its peaceful environment, lush gardens, and mesmerizing sunsets. Built by the Chalukyas, it covers an expansive area surrounded by walking paths and food stalls. Locals and tourists gather in the evenings to enjoy boating, horse rides, and famous Kolhapuri bhel. The lakefront’s cool breeze and tranquil reflections make it a favorite family spot. With historical charm and natural beauty, Rankala Lake perfectly captures Kolhapur’s relaxing, timeless essence."
  },
  {
    "title": "New Palace Museum",
    "description": "The New Palace, also known as Shahu Palace, is a stunning example of Indo-Saracenic architecture built in the late 19th century. Surrounded by sprawling gardens, it now houses a museum displaying royal artifacts, weapons, hunting trophies, and portraits of the Kolhapur rulers. The grand Durbar Hall, with its stained glass panels and carved balconies, showcases regal splendor. Visitors feel transported into a bygone era of Maratha royalty. The palace continues to house the descendants of Chhatrapati Shahu Maharaj, keeping the royal legacy alive."
  },
  {
    "title": "Panhala Fort",
    "description": "Panhala Fort, perched high in the Sahyadri mountains about 20 km from Kolhapur, is steeped in Maratha history. It was a strategic stronghold for Chhatrapati Shivaji Maharaj and later Sambhaji Maharaj. The fort’s massive ramparts, Andhar Bavadi (Hidden Well), and ancient gateways narrate tales of valor and strategy. The panoramic view from the top is breathtaking, especially at sunrise and sunset. Surrounded by mist during monsoon, Panhala becomes a dreamy destination combining adventure, history, and scenic beauty."
  },
  {
    "title": "Jyotiba Temple",
    "description": "Located atop a hill about 17 km from Kolhapur, Jyotiba Temple is a revered pilgrimage site dedicated to Lord Jyotiba — an incarnation of Lord Shiva. The temple complex offers magnificent views of the valleys below, and its pink-hued surroundings (from devotees’ ritual offerings) make it truly unique. The annual Jyotiba Yatra attracts thousands of devotees in vibrant processions. The mountain breeze, devotional chants, and divine ambiance together create a spiritual experience that uplifts the soul."
  },
  {
    "title": "Kaneri Math (Siddhagiri Museum)",
    "description": "Kaneri Math, also known as Siddhagiri Gramjivan Museum, is an open-air sculpture museum located at Kaneri near Kolhapur. It beautifully depicts India’s ancient self-sustained village life through over 300 realistic clay and bronze statues. The museum, spread across lush greenery, educates visitors about rural wisdom, craftsmanship, and sustainability. It’s both educational and inspiring — a must-visit for families and children. The adjoining monastery adds spiritual calm to this creative cultural experience."
  },
  {
    "title": "Gagangad Fort and Gagangiri Ashram",
    "description": "Gagangad Fort, nestled deep in the Western Ghats about 50 km from Kolhapur, offers a serene mix of history and spirituality. The fort’s forested surroundings and hilltop views are mesmerizing, while the Gagangiri Maharaj Ashram nearby attracts devotees seeking peace and meditation. The route to Gagangad winds through dense forests, making it a favorite for trekkers and nature lovers. Mist-covered peaks, chirping birds, and tranquil silence make it one of Kolhapur’s most soul-soothing outstation getaways."
  },
  {
    "title": "Bhavani Mandap",
    "description": "Bhavani Mandap is a historic structure located near Mahalaxmi Temple that once served as a royal court and military office during the Maratha rule. The building’s massive arches, secret chambers, and cannon displays reflect Kolhapur’s regal heritage. Inside, a temple dedicated to Goddess Tulja Bhavani adds spiritual significance. Visitors can explore the exhibits showcasing artifacts from the Peshwa era. Bhavani Mandap stands as a living reminder of Kolhapur’s political power and artistic excellence."
  },
  {
    "title": "Radhanagari Wildlife Sanctuary",
    "description": "Radhanagari Wildlife Sanctuary, a UNESCO-recognized reserve, lies about 60 km from Kolhapur and is home to the majestic Indian bison (gaur), leopards, deer, and over 250 bird species. Dense forests, sparkling streams, and calm lakes make it a paradise for wildlife enthusiasts and photographers. Jeep safaris take visitors deep into nature’s lap, where every turn reveals something new. The sanctuary’s untouched beauty and biodiversity offer a perfect escape from city life while promoting eco-tourism and conservation awareness."
  },
  {
    "title": "Dajipur Bison Sanctuary",
    "description": "Situated on the border of Sindhudurg and Kolhapur districts, Dajipur Bison Sanctuary is an offbeat gem for wildlife lovers. Surrounded by rugged mountains and lush valleys, it is known for its population of Indian bisons and a variety of birds and reptiles. Trekking trails, waterfalls, and forest lodges make it an adventurous yet peaceful experience. The sanctuary’s raw charm and natural tranquility are ideal for those looking to connect deeply with nature. It’s a hidden jewel in Kolhapur’s green crown."
  }
],



"services": [
    {
      "name": "Pune to Kolhapur Cab",
      "description": "Book a comfortable and reliable cab from Pune to Kolhapur with options for AC and Non-AC vehicles, ensuring a smooth and hassle-free journey. Ideal for family trips, corporate travel, or long-distance leisure rides, with professional drivers, flexible pickup and drop points, luggage support, and 24x7 service availability for complete convenience."
    },
    {
      "name": "Pune to Kolhapur Taxi Service",
      "description": "Avail premium taxi service from Pune to Kolhapur with well-maintained vehicles including Innova and Ertiga. Perfect for one-way trips, outstation travel, and corporate bookings, offering professional chauffeurs, punctual pickups, transparent fares, and online booking options for a seamless travel experience."
    },
    {
      "name": "Pune to Kolhapur Car Hire",
      "description": "Hire a car from Pune to Kolhapur for personal, corporate, or family travel. Choose from a wide range of vehicles with AC and Non-AC options, enjoy professional driver service, luggage assistance, flexible schedules, and hassle-free online booking with competitive and transparent pricing."
    },
    {
      "name": "Pune to Kolhapur AC Cab",
      "description": "Travel in comfort with AC cabs from Pune to Kolhapur, ensuring a cool and relaxing journey. Ideal for long-distance trips, corporate travel, or family outings, with professional drivers, luggage support, multiple vehicle options, online booking, and transparent fare structure."
    },
    {
      "name": "Pune to Kolhapur Non AC Cab",
      "description": "Budget-friendly Non-AC cab service from Pune to Kolhapur, offering comfortable travel with well-maintained vehicles. Suitable for families, groups, or individual travelers seeking affordable outstation rides with professional drivers, luggage assistance, flexible schedules, and easy online booking."
    },
    {
      "name": "Pune to Kolhapur Innova Cab",
      "description": "Hire a spacious and premium Innova cab from Pune to Kolhapur, perfect for family trips, corporate travel, or group outings. Features include AC/non-AC options, professional drivers, luggage support, flexible pickup/drop locations, online booking, and transparent fares for a luxurious yet safe journey."
    },
    {
      "name": "Pune to Kolhapur Ertiga Cab",
      "description": "Rent an Ertiga cab from Pune to Kolhapur for comfortable 7-seater travel. Ideal for small groups or families with AC/non-AC options, professional chauffeur service, luggage support, timely pickups, online booking, and transparent fares, ensuring a smooth and enjoyable journey."
    },
    {
      "name": "Luxury Cab Pune to Kolhapur",
      "description": "Experience premium travel from Pune to Kolhapur with luxury cab options including Innova and Ertiga. Enjoy professional drivers, spacious interiors, AC service, luggage assistance, punctual pickups, online booking, and transparent fare structures, making your long-distance journey comfortable and elegant."
    },
    {
      "name": "Affordable Pune to Kolhapur Cab",
      "description": "Book an affordable cab from Pune to Kolhapur without compromising on comfort or safety. Choose from AC and Non-AC vehicles, professional drivers, luggage assistance, flexible schedules, online booking, and transparent fares for budget-friendly yet reliable outstation travel."
    },
    {
      "name": "Pune to Kolhapur Outstation Cab",
      "description": "Convenient outstation cab service from Pune to Kolhapur, ideal for long-distance travel, corporate trips, or family vacations. Includes AC/Non-AC vehicles, professional drivers, luggage support, online booking, flexible pickup/drop locations, transparent fares, and 24x7 availability for a stress-free journey."
    },
    {
      "name": "Pune to Kolhapur One Way Cab",
      "description": "One-way cab service from Pune to Kolhapur for travelers seeking flexible and convenient options. Choose AC or Non-AC vehicles, Innova or Ertiga, with professional drivers, luggage assistance, online booking, and transparent pricing for a smooth and reliable journey."
    },
    {
      "name": "Pune to Kolhapur Drop Cab",
      "description": "Safe and comfortable drop cab service from Pune to Kolhapur with AC and Non-AC options. Professional drivers, luggage support, flexible pickup and drop points, online booking, and transparent fares ensure a hassle-free travel experience for families, corporate travelers, and groups."
    },
    {
      "name": "Pune to Kolhapur Corporate Cab",
      "description": "Corporate cab service from Pune to Kolhapur with AC and Non-AC options, professional chauffeurs, luggage assistance, flexible schedules, online booking, and transparent fares. Ideal for business trips, client meetings, or group corporate travel requiring punctuality and comfort."
    },
    {
      "name": "Pune to Kolhapur Wedding Cab",
      "description": "Luxury and spacious cab service from Pune to Kolhapur for weddings, offering AC/non-AC vehicles, professional drivers, luggage support, flexible pickup/drop locations, online booking, and transparent fares. Perfect for ensuring timely and comfortable travel for wedding parties and guests."
    },
    {
      "name": "Pune to Kolhapur Online Booking",
      "description": "Instant online booking for cabs from Pune to Kolhapur with secure payment options. Choose from AC, Non-AC, Innova, Ertiga, or luxury vehicles with professional drivers, luggage assistance, flexible pickup/drop points, transparent fares, and 24x7 customer support for a seamless travel experience."
    }
  ],
  "tableData": [
    ["Pune to Kolhapur Cab", "Pune to Kolhapur Taxi Service"],
    ["Pune to Kolhapur Car Hire", "Pune to Kolhapur AC Cab"],
    ["Pune to Kolhapur Non AC Cab", "Pune to Kolhapur Innova Cab"],
    ["Pune to Kolhapur Ertiga Cab", "Luxury Cab Pune to Kolhapur"],
    ["Affordable Pune to Kolhapur Cab", "Pune to Kolhapur Outstation Cab"],
    ["Pune to Kolhapur One Way Cab", "Pune to Kolhapur Drop Cab"],
    ["Pune to Kolhapur Corporate Cab", "Pune to Kolhapur Wedding Cab"],
    ["Pune to Kolhapur Online Booking", ""]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Pune to Kolhapur Cab Service",
    "WhyChoosedescription": "Sai Trupti Cabs  offers reliable and comfortable cab services from Pune to Kolhapur — ideal for business trips, leisure travel, and family outings."
  },
  {
    "WhyChooseheading": "Transparent & Competitive Fare",
    "WhyChoosedescription": "We provide clear and affordable one-way fares from Pune to Kolhapur with no hidden charges, making your travel cost-effective and hassle-free."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, or Tempo Travellers to suit your group size, luggage, and comfort preferences for the Pune to Kolhapur route."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our courteous and trained drivers ensure a safe, smooth, and timely journey between Pune and Kolhapur."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop Locations",
    "WhyChoosedescription": "We offer convenient pickups from anywhere in Pune and drop-offs at any location in Kolhapur, including hotels, railway stations, or residences."
  },
  {
    "WhyChooseheading": "Clean & Well-Maintained Vehicles",
    "WhyChoosedescription": "All vehicles are regularly serviced, sanitized, and maintained to provide comfort, safety, and reliability during the long drive from Pune to Kolhapur."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available around the clock to assist with bookings, route planning, and any travel queries."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Book your Pune to Kolhapur cab easily via call, WhatsApp, or our website — with instant confirmation and prompt vehicle dispatch."
  }
]
























  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs  offer Pune to Kolhapur cab services?',
    answer: 'Yes, Sai Trupti Cabs  provides reliable and affordable Pune to Kolhapur cab services for one-way trips, round trips, and group travel.',
  },
  {
    question: 'How can I book a Pune to Kolhapur cab with Sai Trupti Cabs?',
    answer: 'You can easily book your Pune to Kolhapur cab through our website, mobile app, or by contacting our 24×7 customer support team for instant confirmation.',
  },
  {
    question: 'What types of cabs are available from Pune to Kolhapur?',
    answer: 'We offer a wide range of vehicles including hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, Urbania, and Tempo Travellers to suit your travel needs, group size, and budget.',
  },
  {
    question: 'Are the drivers experienced for Pune to Kolhapur trips?',
    answer: 'Yes, all our drivers are professional, courteous, and trained for long-distance travel, ensuring a safe and comfortable journey from Pune to Kolhapur.',
  },
  {
    question: 'Can I hire a cab from Pune to Kolhapur for family, corporate, or group travel?',
    answer: 'Certainly. Our cab services cater to family trips, group tours, corporate travel, and sightseeing journeys between Pune and Kolhapur.',
  },
  {
    question: 'Is the Pune to Kolhapur cab service available 24×7?',
    answer: 'Yes, Sai Trupti Cabs offers 24×7 cab services for Pune to Kolhapur trips to fit your schedule and travel plans.',
  },
  {
    question: 'What are the fares for Pune to Kolhapur cab services?',
    answer: 'Cab fares from Pune to Kolhapur start from approximately ₹2,500 for sedans and ₹3,500–₹5,000 for SUVs and larger vehicles, depending on vehicle type, distance, and travel requirements.',
  },
  {
    question: 'What payment methods are accepted for Pune to Kolhapur cab bookings?',
    answer: 'We accept payments via UPI, credit/debit cards, bank transfers, and digital wallets for secure and hassle-free transactions.',
  },
  {
    question: 'What safety and hygiene protocols are followed for Pune to Kolhapur cabs?',
    answer: 'All vehicles are sanitized before every trip, and our drivers follow strict hygiene and safety measures to ensure a secure journey.',
  },
  {
    question: 'Is customer support available during Pune to Kolhapur cab trips?',
    answer: 'Yes, our dedicated 24×7 customer support team is available to assist you before, during, and after your Pune to Kolhapur cab journey.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sandeep Jadhav',
    feedback: 'I booked a cab from Pune to Kolhapur with Sai Trupti Cabs. The car was clean, comfortable, and the driver was very professional.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Rekha Patil',
    feedback: 'Sai Trupti Cabs made our Pune to Kolhapur trip smooth and hassle-free. Highly recommend their service for long-distance travel.',
    rating: 5,
  },
];











































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];














const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Kolhapur Cab Service",
  "image": "https://saitrupticabs.com/assets/images/pune-to-kolhapur-cab.jpg",
  "description": "Sai Trupti Cabs offers reliable Pune to Kolhapur cab service with AC, Non-AC, Innova Crysta, Ertiga and sedan options. Book one way, round trip, corporate travel, airport transfer or wedding cabs at affordable prices with 24x7 service and professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Trupti Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "6845"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2499",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/pune-to-kolhapur-cab",
    "itemCondition": "https://schema.org/NewCondition"
  }
};








  return (
    <div>
      <Helmet>
  <title>Pune to Kolhapur Cab Service | One Way Taxi ₹2499 | Sai Trupti Cabs</title>

  <meta 
    name="description" 
    content="Book Pune to Kolhapur cab at best price ₹2499 with Sai Trupti Cabs. One way taxi, round trip, Innova Crysta, Ertiga, sedan & SUV available. Safe, reliable and 24x7 cab service with professional drivers. Call now!" 
  />

  <meta 
    name="keywords" 
    content="pune to kolhapur cab, pune to kolhapur taxi, pune to kolhapur cab service, one way cab pune to kolhapur, pune to kolhapur taxi fare, pune to kolhapur innova crysta, pune to kolhapur ertiga cab, pune to kolhapur sedan cab, cheap pune to kolhapur cab, best cab service pune to kolhapur, pune to kolhapur drop taxi, pune to kolhapur round trip cab, outstation cab pune to kolhapur, pune to kolhapur online cab booking" 
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/51.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetokolhpaurcab;